define('modules/form_editor/views/preview_check_group',['require','exports','module','./preview_group_base','./preview_check_item','../../editor/models/editorstate','ldsh!../templates/preview_check_group_amp','ldsh!../templates/preview_group'],function(require, exports, module){
  "use strict";

  var InputGroupBase = require('./preview_group_base'),
      CheckItemView = require('./preview_check_item'),
      EditorState = require('../../editor/models/editorstate');

  module.exports = InputGroupBase.extend({
    template: null,
    itemView: CheckItemView,

    initialize: function(options) {
      this.template = EditorState.getAMPState() ?
        require('ldsh!../templates/preview_check_group_amp') :
        require('ldsh!../templates/preview_group');

      module.exports.__super__.initialize.apply(this, arguments);
    }
  });
});

